"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var GN = require("qc-global-navigation");
var monitoring_1 = require("../../services/monitoring");
var GlobalNav = /** @class */ (function (_super) {
    __extends(GlobalNav, _super);
    function GlobalNav(props) {
        return _super.call(this, props) || this;
    }
    GlobalNav.prototype.componentDidMount = function () {
        monitoring_1.default('globalNav');
        // Init global nav with config object
        GN.init(this.props.config);
        // Pass along the GN object to cover off other needs
        var unusedReturn = this.props.globalNavRef
            ? this.props.globalNavRef(GN)
            : null;
    };
    GlobalNav.prototype.componentWillReceiveProps = function (newProps) {
        if (JSON.stringify(newProps.config) !== JSON.stringify(this.props.config)) {
            // Pass a new config object to the global nav init method
            GN.init(newProps.config);
            // Pass along the GN object to cover off other needs
            var unusedReturn = newProps.globalNavRef
                ? newProps.globalNavRef(GN)
                : null;
        }
    };
    GlobalNav.prototype.render = function () {
        return null;
    };
    GlobalNav.defaultProps = {
        config: {}
    };
    return GlobalNav;
}(React.Component));
exports.default = GlobalNav;
//# sourceMappingURL=GlobalNav.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/GlobalNav/GlobalNav.js
// module id = 207
// module chunks = 0